var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReleaseMandatory = function SvgReleaseMandatory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 32,
    viewBox: "0 0 40 32"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-4 -10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4h40v40H4z",
    style: {
      fill: "none"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 6,
    fill: "#E2553D"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AE875C",
    fillRule: "nonzero",
    d: "M10 16l-6-6h12l6 6z",
    style: {
      fill: "#AE875C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#88653E",
    fillRule: "nonzero",
    d: "M38 16l6-6H28l-6 6z",
    style: {
      fill: "#88653E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE875C",
    fillRule: "nonzero",
    d: "M38 28.25A8.01 8.01 0 0 0 28.25 38H10V16h28v12.25z",
    style: {
      fill: "#AE875C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C09D75",
    fillRule: "nonzero",
    d: "M10 16h12v22H10z",
    style: {
      fill: "#C09D75"
    }
  })));
};
export default SvgReleaseMandatory;